import { render, staticRenderFns } from "./IbDrop.vue?vue&type=template&id=7d23d575"
import script from "./IbDrop.vue?vue&type=script&lang=js"
export * from "./IbDrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports